import React, {useContext} from 'react';
import logo from "../../img/logo.png";
import {Button} from "primereact/button";
import { useTranslation } from 'react-i18next';
import LanguageSelector from "../../Shared/LanguageSelector";
import {KeycloakContext} from "../../context/KeycloakContext";
import Logo from "../../Shared/Logo"

// Definición de un componente funcional
const Login = ({ language }) => {
    const { kc , appInsights, theme } = useContext( KeycloakContext )

    const { t } = useTranslation();

    return (
        <div className="mimetika-login container mx-auto min-h-screen flex justify-content-center align-items-center">
            <div>
                <LanguageSelector appInsights={appInsights}/>
                <div className="mb-2 mt-2 sm:mt-32 md:mt-0 lg:mt-0 text-6xl text-center font-light text-gray">
                    {t('Welcome to')}
                </div>
                <div className="relative my-6">
                     <Logo theme={theme}/>
                </div>
                <div><Button onClick={() => { kc.login({ locale:language }) }} label={t('Login')} className="login-button min-w-40 "   data-cy="login-button" /></div>
            </div>
        </div>
    );
}

export default Login;
